import { formatDate, formatDateISO } from '@helpers/date';
import { imageUrl } from '@helpers/image';
import { Device, until } from '@helpers/media';
import React from 'react';
import S from './NewsCard.styles';
const NewsCard = ({ id, date, favourite = false, featured, image, isLoggedIn = false, tag, title, url, }) => {
    const ratio = featured ? 1 : 0.5;
    return (React.createElement(S.Container, { "data-featured": featured, "data-image": !!image },
        React.createElement(S.Link, { href: url, title: title },
            image && (React.createElement(S.ImageWrapper, null,
                React.createElement(S.ImageWrapperInner, null,
                    React.createElement(S.Image, { alt: "", draggable: false, loading: "lazy", sizes: [
                            `${until(Device.TabletLarge)} 50vw`,
                            `${until(Device.Desktop)} 33vw`,
                            `25vw`,
                        ].join(', '), src: imageUrl(image, { width: 241, heightratio: ratio }), srcSet: [
                            `${imageUrl(image, { width: 241, heightratio: ratio })} 241w`,
                            `${imageUrl(image, { width: 375, heightratio: ratio })} 375w`,
                            `${imageUrl(image, { width: 480, heightratio: ratio })} 480w`,
                            `${imageUrl(image, { width: 640, heightratio: ratio })} 640w`,
                        ].join(', ') })))),
            React.createElement(S.ContentWrapper, null,
                featured && React.createElement(S.Badge, null, "Featured"),
                React.createElement(S.Tag, null, tag),
                React.createElement(S.Title, null, title),
                React.createElement(S.Date, { dateTime: formatDateISO(date) }, formatDate(date)),
                React.createElement(S.FavouriteToggle, { id: id, initialValue: favourite, isLoggedIn: isLoggedIn })))));
};
export default NewsCard;
